/**
 * Mobile Detection và Core Mobile Utilities
 * Phát hiện và tối ưu trải nghiệm mobile
 */

class MobileDetection {
  constructor() {
    this.isMobile = this.detectMobile();
    
    this.init();
  }

  /**
   * Khởi tạo mobile detection và setup utilities
   */
  init() {
    // Setup viewport for mobile
    if (this.isMobile) {
      this.setupMobileViewport();
    }
  }

  /**
   * Phát hiện thiết bị mobile
   */
  detectMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
    const screenWidth = window.screen.width <= 768;
    const touchSupport = 'ontouchstart' in window;
    
    return mobileRegex.test(userAgent) || screenWidth || touchSupport;
  }


  /**
   * Setup mobile viewport
   */
  setupMobileViewport() {
    let viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.name = 'viewport';
      document.head.appendChild(viewport);
    }
    
    const content = [
      'width=device-width',
      'initial-scale=1.0',
      'maximum-scale=1.0',
      'user-scalable=no',
      'viewport-fit=cover'
    ].join(', ');
    
    viewport.content = content;
  }

  /**
   * Haptic feedback cho mobile
   */
  hapticFeedback(type = 'light') {
    if (!this.isMobile) return false;
    
    try {
      if ('vibrate' in navigator) {
        const patterns = {
          light: [10],
          medium: [50],
          heavy: [100],
          success: [50, 50, 50],
          warning: [100, 50, 100],
          error: [200, 100, 200]
        };
        
        const pattern = patterns[type] || patterns.light;
        navigator.vibrate(pattern);
        return true;
      }
    } catch (error) {
      console.warn('Haptic feedback not available:', error);
    }
    return false;
  }

  /**
   * Share content (nếu hỗ trợ Web Share API)
   */
  async shareContent(data) {
    if ('share' in navigator) {
      try {
        await navigator.share(data);
        return true;
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error sharing:', error);
        }
        return false;
      }
    } else {
      // Fallback to clipboard
      if ('clipboard' in navigator) {
        try {
          await navigator.clipboard.writeText(data.url || data.text || '');
          return true;
        } catch (error) {
          console.error('Error copying to clipboard:', error);
          return false;
        }
      }
    }
    return false;
  }

  /**
   * Get device info
   */
  getDeviceInfo() {
    return {
      isMobile: this.isMobile,
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
      pixelRatio: window.devicePixelRatio || 1,
      language: navigator.language,
      online: navigator.onLine
    };
  }
}

// Initialize Mobile Detection
const pwaDetection = new MobileDetection();

// Export for use in other modules
export default pwaDetection;

// Global access
window.pwaDetection = pwaDetection;